import { defineMessages } from 'react-intl';

import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { intlService } from '~/i18n/IntlService';

const messages = defineMessages({
  groupsGroupName: {
    id: 'GetPermissionsResponse.groupsGroupName',
    defaultMessage: 'Groups',
    description: 'Permission group title for Groups',
  },
  groupsEditName: {
    id: 'GetPermissionsResponse.groupsEditName',
    defaultMessage: 'Groups: Edit',
    description: 'Permission name for editing groups',
  },
  groupsEditDescription: {
    id: 'GetPermissionsResponse.groupsEditDescription',
    defaultMessage:
      'Create, view, edit, or delete groups. Can also view or edit individual files in groups subject to folder access control settings.',
    description: 'Explains capabilities for editing groups',
  },
  groupsViewName: {
    id: 'GetPermissionsResponse.groupsViewName',
    defaultMessage: 'Groups: View',
    description: 'Permission name for viewing groups',
  },
  groupsViewDescription: {
    id: 'GetPermissionsResponse.groupsViewDescription',
    defaultMessage:
      'View groups. Can also view or edit individual files in groups subject to folder access control settings.',
    description: 'Explains capabilities for viewing groups',
  },
});

const legacyFeature = {
  editPermissionId: 'b7fbf44c-e2a3-4af8-b3f1-7c7d02abca6f',
  viewPermissionId: 'f3a6c2f2-0a76-42b0-942a-8540eeb434f9',
  id: 'document_group',
};

const groupedTicketsAndDocsFeature = {
  editPermissionId: '8f7a4b2e-9c1d-4e3f-b5a6-7d8c9e0f1a2b',
  viewPermissionId: '3e5d7c9b-1a2f-4e6d-8c0a-5b7e9d1c3f4a',
  id: 'entity_group',
};

export const getGroupPermission = () => {
  const intl = intlService.getIntl();
  const hasGroupedTicketsAndDocs = getFlag(FlagType.GroupedTicketsAndDocs);
  const feature = hasGroupedTicketsAndDocs
    ? groupedTicketsAndDocsFeature
    : legacyFeature;

  return [
    {
      type: 'permission_group',
      id: 'c3837d2f-6f8e-4476-82a3-00f82d1f022c',
      attributes: {
        name: intl.formatMessage(messages.groupsGroupName),
        permissions: [
          {
            id: feature.editPermissionId,
            name: intl.formatMessage(messages.groupsEditName),
            description: intl.formatMessage(messages.groupsEditDescription),
            feature: feature.id,
            premium: true,
            relations: ['feature_creator', 'feature_editor', 'feature_deleter'],
          },
          {
            id: feature.viewPermissionId,
            name: intl.formatMessage(messages.groupsViewName),
            description: intl.formatMessage(messages.groupsViewDescription),
            premium: true,
            feature: feature.id,
            relations: ['feature_viewer'],
          },
        ],
      },
    },
  ];
};
